export const DATAJSON = [
  {
    type: "subtittle",
    label: "Datos de la empresa",
    fieldName: "",
  },
  {
    type: "text",
    label: "Razón social",
    fieldName: "socialReason",
    required: true,
  },
  {
    type: "text",
    label: "Nombre de fantasia",
    fieldName: "fantasyName",
    required: true,
  },
  {
    type: "text",
    label: "CUIT",
    fieldName: "cuit",
    required: true,
    readOnly: true,
  },
  /*   {
    type: "text",
    label: "Condición frente al iva",
    fieldName: "ivaCondition",
    required: true
  }, */
  {
    type: "select",
    label: "Condición frente al iva",
    fieldName: "ivaCondition",
    options: [
      {
        name: "",
        value: "",
      },
    ],
    required: true,
  },
  {
    type: "select",
    label: "Rubro de la empresa",
    fieldName: "heading",
    options: [
      {
        name: "",
        value: "",
      },
    ],
    required: true,
  },
  {
    type: "select",
    label: "ART",
    fieldName: "ART",
    required: false,
  },
  {
    type: "subtittle",
    label: "Datos de contacto",
    fieldName: "",
  },
  {
    type: "text",
    label: "Dirección",
    fieldName: "residence",
    required: true,
  },
  {
    type: "text",
    label: "Localidad",
    fieldName: "location",
    required: true,
  },
  {
    type: "text",
    label: "Provincia",
    fieldName: "province",
    required: true,
  },
  {
    type: "text",
    label: "Código postal",
    fieldName: "postalCode",
    required: true,
  },
  {
    type: "text",
    label: "Teléfono",
    fieldName: "phoneNumber",
    required: true,
  },
  {
    type: "text",
    label: "Email",
    fieldName: "email",
    required: true,
  },
];
